import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import FormField from "../../../../../dynamicFormBuilder/FormField";
import { confirm } from "devextreme/ui/dialog";
import { MESSAGES } from "../../../../../common/Messages";
import { SPLIT_METHOD_SCHEMA, TRANSACTION_DETAIL_SCHEMA,SPLIT_TARGET_MODE } from "./Layout";
const emptyGuid = "00000000-0000-0000-0000-000000000000";

const emptyDetailFields = () => ({
    RecordNumber: "",
    IdentityId: "",
    TransactionNumber: "",
    StageDisplay: "",
    StatusDisplay: "",
    OrderDate: null,
    _rowId: null,
});

function mapListRowToDetail(row) {
    if (!row) return emptyDetailFields();
    return {
        RecordNumber: row.RECORD ?? row.Record ?? "",
        IdentityId: row.CUSTOMERIDENTITYID ?? row.CustomerIdentityId ?? "",
        TransactionNumber: row.TRANSACTIONNUMBER ?? row.TransactionNumber ?? "",
        StageDisplay: row.STAGE ?? row.Stage ?? "",
        StatusDisplay: row.STATUS ?? row.Status ?? "",
        OrderDate: row.TRANSACTIONDATE ?? row.TransactionDate ?? null,
        _rowId: row.ROWID ?? row.RowId,
    };
}

function SplitOrderTargetPopup(props) {
    const visible =props.showTargetPopup === true;
    var currentUser = props.oidc.user;
    const [formFields, setFormFields] = useState({ SplitMethod: SPLIT_TARGET_MODE.New });
    const [detailFields, setDetailFields] = useState(emptyDetailFields());

    const methodRefs = useRef({});
    const detailRefs = useRef({});
    const closingViaOkRef = useRef(false);

    const isExisting = formFields.SplitMethod === SPLIT_TARGET_MODE.Existing;

    const clearDetailFields = useCallback(() => {
        setDetailFields(emptyDetailFields());
    }, []);

    const resetState = useCallback(() => {
        setFormFields({ SplitMethod: SPLIT_TARGET_MODE.New });
        setDetailFields(emptyDetailFields());
    }, []);

    const closePopup = () => {
        // Skip the cancel side-effect when the dialog is closing because OK was pressed.
        if (closingViaOkRef.current) {
            closingViaOkRef.current = false;
            return;
        }
        if (props.onCancel) {
            props.onCancel();
        } else {
            props.setShowTargetPopup(false);
        }
    };

    useEffect(() => {
        if (!visible) return;
        resetState();
    }, [visible, resetState]);
    useEffect(() => {
        if (props.selectedHeader) {
            setDetailFields(mapListRowToDetail(props.selectedHeader));
        }
    }, [ props.selectedHeader]);

    const handleSplitMethodChange = (name, value) => {
        if (name !== "SplitMethod") return;
        setFormFields({ SplitMethod: value });
        if (value === SPLIT_TARGET_MODE.New) {
            clearDetailFields();
        }
    };

    const handleOk = async () => {
        if (isExisting) {
            const selectedRowId = props.selectedHeader?.ROWID ?? props.selectedHeader?.RowId;
            // Delphi btnOKClick: existing chosen but no order selected -> confirm fallback to new.
            if (!selectedRowId || selectedRowId === emptyGuid) {
                const proceed = await confirm(
                    "An existing order was not selected.<br/>Continue the split process creating a new order?",
                    MESSAGES.CONFIRM
                );
                if (!proceed) {
                    if (props.onCancel) props.onCancel();
                    return;
                }
                closingViaOkRef.current = true;
                props.setShowTargetPopup(false);
                props.onConfirm(null);
                return;
            }
            closingViaOkRef.current = true;
            props.setShowTargetPopup(false);
            props.onConfirm(selectedRowId);
            return;
        }
        // Create a new order
        closingViaOkRef.current = true;
        props.setShowTargetPopup(false);
        props.onConfirm(null);
    };



    return (
        <>
            <Popup
                visible={visible}
                onHiding={closePopup}
                title="Split Method Advanced"
                width={480}
                height={560}
                showCloseButton
                dragEnabled
                resizeEnabled={false}
            >
                <div style={{ padding: "12px 20px 16px" }}>
                    <FormField
                        layoutId="9109CAC0-F81C-4F3F-9F8D-91CC54394E69"
                        layoutName="OM Split Method"
                        defaultFormSchema={SPLIT_METHOD_SCHEMA}
                        formFields={formFields}
                        setformFields={setFormFields}
                        handleFieldValueChange={handleSplitMethodChange}
                        formRefs={methodRefs}
                        onFormLoad={() => {}}
                        currrentUser={currentUser}
                        hasOnlyOneColumn
                    />

                    {isExisting && (
                        <div style={{ marginTop: 4, marginBottom: 4 }}>
                            <Button
                                text="Find Transaction"
                                icon="search"
                                type="default"
                                stylingMode="contained"
                                onClick={()=>props.onFindTransaction(true)}
                            />
                        </div>
                    )}

                        <FormField
                            layoutId="853F0CA0-9ADD-4EE1-96CD-AD1E4B64113C"
                            layoutName="OM Split Method Detail"
                            defaultFormSchema={TRANSACTION_DETAIL_SCHEMA}
                            formFields={detailFields}
                            setformFields={setDetailFields}
                            handleFieldValueChange={() => {}}
                            formRefs={detailRefs}
                            onFormLoad={() => {}}
                            currrentUser={currentUser}
                            hasOnlyOneColumn
                        />

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 12,
                            marginTop: 20,
                        }}
                    >
                        <Button text="OK" icon="check" type="default" width={100} onClick={handleOk} />
                        <Button text="Cancel" icon="close" width={100} onClick={closePopup} />
                    </div>
                </div>
            </Popup>
        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SplitOrderTargetPopup);
